import mapToLinkTrackEvents from "./mapToLinkTrackEvents";
import getItemsTypeGlobalVars from "./getItemsTypeGlobalVars";

export default ({ trackLink: { events, vars }, itemsType }, mappedGlobals) => ({
  linkTrackEvents: mapToLinkTrackEvents(events),
  linkTrackVars: vars
    .concat(Object.keys(mappedGlobals), getItemsTypeGlobalVars(itemsType))
    .join(",")
});
